import PropTypes from 'prop-types';
import React from 'react';

const STATUS_IDLE = 0;
const STATUS_TRANSACTION_SUCCESS = 1;
const STATUS_TRANSACTION_FAIL = -1;

function getOrderStatusId() {
  if (!process.browser) {
    return STATUS_IDLE;
  }

  const name = 'orderStatusId';
  const params = new URLSearchParams(window.location.search);

  if (!params.has(name)) {
    return STATUS_IDLE;
  }

  const orderStatusId = parseInt(params.get(name), 10);

  if (Number.isNaN(orderStatusId)) {
    return STATUS_TRANSACTION_FAIL;
  }

  return orderStatusId > 0
    ? STATUS_TRANSACTION_SUCCESS
    : STATUS_TRANSACTION_FAIL;
}

export const OrderFormContainer = ({ form, success, fail }) => {
  const status = getOrderStatusId();

  switch (status) {
    case STATUS_TRANSACTION_SUCCESS:
      return <>{success}</>;
    case STATUS_TRANSACTION_FAIL:
      return <>{fail}</>;
    default:
      return <>{form}</>;
  }
};

OrderFormContainer.propTypes = {
  form: PropTypes.node,
  success: PropTypes.node,
  fail: PropTypes.node,
};
